// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/communication/COMMUNICATION.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: Roboto;
}

.communication_cardMainRowHeading {
  padding: 7vw;
  padding-bottom: 2vw;
}
.communication_cardHeading {
  color: #fff;
  text-align: center;
  font-size: 5.1vh;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
}
@media (max-width: 768px) {
  .communication_cardHeading {
    font-size: 4vw;
    margin-left: 2vw;
    margin-right: 2vw;
  }
}
@media (max-width: 576px) {
  .communication_cardHeading {
    font-size: 5vw;
    margin-left: 2vw;
    margin-right: 2vw;
  }
}
.communication_hoverMainDiv {
  height: 70vh;
}
@media (max-width: 576px) {
  .communication_hoverMainDiv {
    margin-top: 4vw;
    margin-left: 1rem;
    margin-right: 1rem;
  }
}

.mainDiv {
  padding-left: 4vw;
  padding-right: 4vw;
  padding-top: 1vw;
  background-color: rgb(29, 26, 54) !important;
}

.textcssView {
  opacity: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(137deg, #ffb6a0 0%, #f0592a 18.54%, #253c77 100%);
  border-radius: 0px 0px 20px 20px;
  height: 13vw;
}

.textcssView:hover {
  opacity: 1;
  transition: all 1s;
}

.bgImage {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
  background-size: cover;
  border-radius: 20px;
}

.bgTop {
  height: 23vw;
}

.overlyText {
  font-size: 1.3vw;
  text-align: center;
  padding: 0.5vw;
  line-height: 150%;
  color: #fff;
}

.comText {
  margin-top: 2vw;
  font-size: 20px;
  text-align: center;
  color: #fff;
}
@media (min-width: 2560px) {
  .comText {
    font-size: 25px;
  }
}

@media (max-width: 1200px) {
  .bgTop {
    height: 22vw;
  }
  .textcssView {
    height: 18vw;
  }
}
@media (max-width: 992px) {
  .bgTop {
    height: 23vw;
  }
  .textcssView {
    height: 19vw;
  }
}
@media (max-width: 768px) {
  .bgTop {
    height: 35vw;
  }
  .textcssView {
    height: 22vw;
  }
  .overlyText {
    font-size: 2vw;
  }
}
@media (max-width: 576px) {
  .mainDiv {
    height: 100vh;
    padding-left: 10vw;
    padding-right: 10vw;
    background-color: rgb(29, 26, 54) !important;
  }
  .bgTop {
    height: 30vh;
  }
  .textcssView {
    height: 25vh;
  }
  .overlyText {
    font-size: 5vw;
  }
}
/* src/App.css */
.communication-card > .container {
  padding-bottom: 60px;
}

.card {
  width: 315px !important;
  height: 435px !important;
  overflow: hidden; /* Ensure the overlay text doesn't overflow */
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  cursor: pointer;
}
@media (min-width: 2560px) {
  .card {
    width: 344px !important;
    height: 473.5px !important;
  }
}
@media (max-width: 340px) {
  .card {
    width: 280px !important;
  }
}

.card:hover .overlay-text {
  display: block;
  /* opacity: 1; */
}

.overlay-text {
  margin-top: auto;
  display: none;
  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 30px */
  border-radius: 0px 0px 15px 15px;
  padding: 28.5px 11.25px;
  background: linear-gradient(137deg, #ffb6a0 0%, #f0592a 18.54%, #253c77 100%);
}

.overlay-text p {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/Components/CommunicationCard/communicationCard.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEE;EACE,YAAA;EACA,mBAAA;AACJ;AACE;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AACJ;AAAI;EAPF;IAQI,cAAA;IACA,gBAAA;IACA,iBAAA;EAGJ;AACF;AAFI;EAZF;IAaI,cAAA;IACA,gBAAA;IACA,iBAAA;EAKJ;AACF;AAHE;EACE,YAAA;AAKJ;AAJI;EAFF;IAGI,eAAA;IACA,iBAAA;IACA,kBAAA;EAOJ;AACF;;AAJA;EAEE,iBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,4CAAA;AAKF;;AAHA;EACE,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,6EAAA;EACA,gCAAA;EACA,YAAA;AAMF;;AAJA;EACE,UAAA;EACA,kBAAA;AAOF;;AALA;EACE,2EAAA;EAEA,sBAAA;EACA,mBAAA;AAOF;;AALA;EACE,YAAA;AAQF;;AANA;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;AASF;;AAPA;EAGE,eAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AAQF;AAPE;EAPF;IAQI,eAAA;EAUF;AACF;;AARA;EACE;IACE,YAAA;EAWF;EATA;IACE,YAAA;EAWF;AACF;AATA;EACE;IACE,YAAA;EAWF;EATA;IACE,YAAA;EAWF;AACF;AATA;EACE;IACE,YAAA;EAWF;EATA;IACE,YAAA;EAWF;EATA;IACE,cAAA;EAWF;AACF;AATA;EACE;IACE,aAAA;IACA,kBAAA;IACA,mBAAA;IACA,4CAAA;EAWF;EATA;IACE,YAAA;EAWF;EATA;IACE,YAAA;EAWF;EATA;IACE,cAAA;EAWF;AACF;AARA,gBAAA;AACA;EACE,oBAAA;AAUF;;AAPA;EACE,uBAAA;EACA,wBAAA;EAGA,gBAAA,EAAA,6CAAA;EACA,sCAAA;EACA,mBAAA;EACA,eAAA;AAQF;AAPE;EATF;IAUI,uBAAA;IACA,0BAAA;EAUF;AACF;AATE;EAbF;IAcI,uBAAA;EAYF;AACF;;AAVA;EACE,cAAA;EACA,gBAAA;AAaF;;AAVA;EACE,gBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,gCAAA;EACA,uBAAA;EACA,6EAAA;AAaF;;AALA;EACE,SAAA;AAQF","sourcesContent":["* {\n  font-family: Roboto;\n}\n.communication {\n  &_cardMainRowHeading {\n    padding: 7vw;\n    padding-bottom: 2vw;\n  }\n  &_cardHeading {\n    color: #fff;\n    text-align: center;\n    font-size: 5.1vh;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%;\n    @media (max-width: 768px) {\n      font-size: 4vw;\n      margin-left: 2vw;\n      margin-right: 2vw;\n    }\n    @media (max-width: 576px) {\n      font-size: 5vw;\n      margin-left: 2vw;\n      margin-right: 2vw;\n    }\n  }\n  &_hoverMainDiv {\n    height: 70vh;\n    @media (max-width: 576px) {\n      margin-top: 4vw;\n      margin-left: 1rem;\n      margin-right: 1rem;\n    }\n  }\n}\n.mainDiv {\n  // height: 36vw;\n  padding-left: 4vw;\n  padding-right: 4vw;\n  padding-top: 1vw;\n  // padding-bottom: 4vw;\n  background-color: rgb(29, 26, 54) !important;\n}\n.textcssView {\n  opacity: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: linear-gradient(137deg, #ffb6a0 0%, #f0592a 18.54%, #253c77 100%);\n  border-radius: 0px 0px 20px 20px;\n  height: 13vw;\n}\n.textcssView:hover {\n  opacity: 1;\n  transition: all 1s;\n}\n.bgImage {\n  background: url(\"../../assets/images/communication/COMMUNICATION.webp\")\n    no-repeat center center;\n  background-size: cover;\n  border-radius: 20px;\n}\n.bgTop {\n  height: 23vw;\n}\n.overlyText {\n  font-size: 1.3vw;\n  text-align: center;\n  padding: 0.5vw;\n  line-height: 150%;\n  color: #fff;\n}\n.comText {\n  // display: flex;\n  // justify-content: center;\n  margin-top: 2vw;\n  font-size: 20px;\n  text-align: center;\n  color: #fff;\n  @media (min-width: 2560px) {\n    font-size: 25px;\n  }\n}\n@media (max-width: 1200px) {\n  .bgTop {\n    height: 22vw;\n  }\n  .textcssView {\n    height: 18vw;\n  }\n}\n@media (max-width: 992px) {\n  .bgTop {\n    height: 23vw;\n  }\n  .textcssView {\n    height: 19vw;\n  }\n}\n@media (max-width: 768px) {\n  .bgTop {\n    height: 35vw;\n  }\n  .textcssView {\n    height: 22vw;\n  }\n  .overlyText {\n    font-size: 2vw;\n  }\n}\n@media (max-width: 576px) {\n  .mainDiv {\n    height: 100vh;\n    padding-left: 10vw;\n    padding-right: 10vw;\n    background-color: rgb(29, 26, 54) !important;\n  }\n  .bgTop {\n    height: 30vh;\n  }\n  .textcssView {\n    height: 25vh;\n  }\n  .overlyText {\n    font-size: 5vw;\n  }\n}\n\n/* src/App.css */\n.communication-card > .container {\n  padding-bottom: 60px;\n}\n\n.card {\n  width: 315px !important;\n  height: 435px !important;\n  // width: 20.22vw !important;\n  // height: 28vw !important;\n  overflow: hidden; /* Ensure the overlay text doesn't overflow */\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n  border-radius: 15px;\n  cursor: pointer;\n  @media (min-width: 2560px) {\n    width: 344px !important;\n    height: 473.5px !important;\n  }\n  @media (max-width: 340px) {\n    width: 280px !important;\n  }\n}\n.card:hover .overlay-text {\n  display: block;\n  /* opacity: 1; */\n}\n\n.overlay-text {\n  margin-top: auto;\n  display: none;\n  color: #fff;\n  text-align: center;\n  font-family: Roboto;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%; /* 30px */\n  border-radius: 0px 0px 15px 15px;\n  padding: 28.5px 11.25px;\n  background: linear-gradient(137deg, #ffb6a0 0%, #f0592a 18.54%, #253c77 100%);\n  // @media (max-width:576px) {\n  //   font-size: 15px;\n  //   padding: 2px 2px;\n  //   border-radius: 0px 0px 11px 11px;\n  // }\n}\n\n.overlay-text p {\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
